export function initBuyButton(): void {
  const buyNowButton = document.getElementById('buy-now-button');

  buyNowButton?.addEventListener('click', () => {
    const form = buyNowButton?.closest('form');
    if (!form) return;
    const returnToInput = document.createElement('input');
    returnToInput.type = 'hidden';
    returnToInput.value = '/checkout';
    returnToInput.name = 'return_to';
    form.appendChild(returnToInput);
    form.submit();
  });
}
